export default __webpack_public_path__ + "static/N0026-703a01c87d6feb74a9080cac8f80ab1a.png";